import img1 from '../images/icon/hosting.png'
import img2 from '../images/icon/provision.png'
import img3 from '../images/icon/badge.png'
import img4 from '../images/icon/chat.png'

const dataCard = [
    {
        stt: '01',
        title:'Video Production',
        desc: ' I direct, capture, and edit. I make Telling your story easy',
        class: 'mr-28',
        link: '/video',

        class2: '',
        img: img1
    },
    {
        stt: '02',
        title:'Photography',
        desc: 'Creatively focused business-minded servicing retail and commercial clients.',
        class: 'mt-45',
        link: '/photo',

        class2: 's2',
        img: img2
    },
    {
        stt: '03',
        title:'Web Development',
        desc: 'Front-end focused, I make websites for small businesses.',
        class: 'mr-28 mt--16',
        link: '/web',

        class2: 's2-m',
        img: img3
    },
    {
        stt: '04',
        title:'History Studio',
        desc: 'Collect, Curate, Create, your historical narrative.',
        class: 'mt-29',
        link: '/my-history-studio',

        class2: 's2',
        img: img4
    },
]

export default dataCard;